module.exports = __webpack_public_path__ + "static/a-family-of-titan-scholars-cta-banner-1920x515-bece03095e78953e13984dae74e43431.jpg";